import * as Yup from 'yup';
import getLanguage, {getAvailableFormLanguages, LanguageId} from '../../../models/utils/Languages';
import ElementConfiguration from '../../../models/form/ElementConfiguration';
import {IOption} from '../../../ui/form/UIOption';

export default class LabelLanguageManager {
  constructor(
    protected readonly languages: LanguageId[],
    protected readonly configuration?: ElementConfiguration,
  ) {
  }

  validationObject() {
    return Object.fromEntries(this.languages.map((languageId) =>
      [languageId, Yup.string().required('Required')]));
  }

  initialFormValues() {
    return Object.fromEntries(getAvailableFormLanguages().map((languageId) =>
      [languageId, this.configuration?.getLabel(languageId) || '']));
  }

  availableLanguages(): IOption<boolean>[] {
    const availableLanguages = getAvailableFormLanguages().filter((x) => this.languages.indexOf(x) < 0);
    return availableLanguages
      .map((langId) => ({
        label: getLanguage(langId), value: langId, selected: false, id: langId,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }
}
